/* Autogenerated file. Do not edit manually. */

/* eslint-disable max-classes-per-file */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/consistent-type-imports */


/*
  Fuels version: {{FUELS}}
{{#if FORC}}
  Forc version: {{FORC}}
{{/if}}
{{#if FUEL_CORE}}
  Fuel-Core version: {{FUEL_CORE}}
{{/if}}
*/
